import {NgModule} from "@angular/core";
import {DropdownModule} from "primeng/primeng";
import {DropdownComponent} from "./DropdownComponent";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        DropdownModule
    ],
    declarations: [
        DropdownComponent
    ],
    exports: [
        DropdownComponent
    ]
})

export class DropdownComponentModule { }


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Dropdown/DropdownComponentModule.ts